<div class="pd" *ngIf="showForm">
    <nz-row class="api-page">
    <nz-col [nzSpan]="24" class="">
        <nz-row>
        <nz-col [nzSpan]="24">
            <h3 class="api-page-title">{{'PROFILE.SECRET-KEY-GENERATOR.LIVE_API_KEY' | translate}}</h3>
        </nz-col>

        <nz-col 
            [nzXs]="24"
            [nzSm]="24"
            [nzMd]="23"
            [nzLg]="23"
            [nzXl]="18"
            [nzXXl]="13"
        >
            <blockquote class="api-article">
                {{'PROFILE.SECRET-KEY-GENERATOR.WARNING' | translate}}
            </blockquote>
            <form *ngIf="hasSecretKey" [formGroup]="secretKeyForm">
            <nz-form-label nzFor="secretKey">{{'PROFILE.SECRET-KEY-GENERATOR.SECRET_KEY' | translate}}</nz-form-label>
            <nz-form-control>
                <nz-input-group [nzAddOnAfter]="suffixIconSearch">
                <input
                    nz-input
                    name="secret_key"
                    type="secret_key"
                    id="secretKey"
                    formControlName="secret_key"
                    class="secret-key"
                    readonly
                />
                </nz-input-group>

                <ng-template #suffixIconSearch>
                    <button *ngIf="canCopyKey" (click)="copyKey()" nz-button nzType="primary">{{'GENERAL.COPY' | translate}}</button>
                    <button *ngIf="!canCopyKey" (click)="showConfirm()" nz-button nzType="primary">{{'PROFILE.SECRET-KEY-GENERATOR.GENERATE_NEW_KEY' | translate}}</button>
                </ng-template>
            </nz-form-control>
            </form>

            <div *ngIf="hasSecretKey">
                <nz-divider></nz-divider>
                <p class="developer-docs">{{'PROFILE.SECRET-KEY-GENERATOR.DEVELOPER_DOCS' | translate}}</p>
                <p>{{'PROFILE.SECRET-KEY-GENERATOR.DOCS_SUBTITLE' | translate}}</p>
                <a class="fetch-json" [href]="jsonUrl" target="_blank" rel="noopener noreferrer">Developer Docs</a>
            </div>
        </nz-col>
        </nz-row>
    </nz-col>

    <nz-col    
        *ngIf="!hasSecretKey"                 
        [nzXs]="24"
        [nzSm]="24"
        [nzMd]="8"
        [nzLg]="8"
        [nzXl]="6"
        [nzXXl]="4"
    >
        <button
        nz-button
        class="v2-btn-primary"
        [nzLoading]="loading"
        nzBlock 
        (click)="showConfirm()"
        >
           <span *ngIf="hasSecretKey">{{'PROFILE.SECRET-KEY-GENERATOR.GENERATE_NEW_KEY' | translate}}</span>
           <span *ngIf="!hasSecretKey">{{'PROFILE.SECRET-KEY-GENERATOR.GENERATE_API_KEY' | translate}}</span> 
        </button>
    </nz-col>
    </nz-row>
</div>
